export default {
  brand: {
    primary: '#000000',
    secondary: '#ffffff',
    tertiary: '#333333',
    quaternary: '#000000',
  },
};
